module.exports = __webpack_public_path__ + "static/assets/87d311cc28e79719f1066f0bf568fef5.svg";